import script from "./UnitSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitSettings.vue?vue&type=script&setup=true&lang=js"

import "./UnitSettings.vue?vue&type=style&index=0&id=6fc0d1f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc0d1f8"]])

export default __exports__